import { LocalStorage } from '@mentimeter/storage';
import { DEPRECATED_SPLIT_KEY_PREFIX, VISITOR_DATA_PREFIX } from '../constants';

const VISITOR_TOKEN_KEY = 'token' as const;
const DEPRECATED_VISITOR_TOKEN_KEY = 'visitorToken' as const;

export type VisitorToken = string;

export function getLocalStorageVisitorToken(): VisitorToken | null {
  const value =
    LocalStorage.getItem(VISITOR_DATA_PREFIX + VISITOR_TOKEN_KEY) ??
    LocalStorage.getItem(
      DEPRECATED_SPLIT_KEY_PREFIX + DEPRECATED_VISITOR_TOKEN_KEY,
    );

  if (value === 'none') return null;

  return value ?? null;
}

export function setLocalStorageVisitorToken(token: VisitorToken) {
  LocalStorage.setItem({
    key: VISITOR_DATA_PREFIX + VISITOR_TOKEN_KEY,
    value: token,
    type: 'functional',
  });
}
